export const LANGUAGES = ['fr', 'en'];